import itemTypeToEmoji from 'util/itemTypeToEmoji';

const allAscii = ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~';

const isOnlyAscii = (str) => {
    return str.split('').every(char => allAscii.includes(char));
};

const getUnownedMessage = (character, allOwnedCharacters) => {
    if (character.length === 1) {
        return oneLetterCheck(character, allOwnedCharacters);
    }
    const itemType = itemTypeToEmoji.getByCharacter(character);
    if (itemType) {
        return 'You don\'t own ' + itemTypeToEmoji[itemType].translation;
    }
    if (isSingleTwoCharEmoji(character)) {
        return 'No one can write ' + character;
    }
    return 'You can\'t write ' + character;
};

const oneLetterCheck = (character, allOwnedCharacters) => {
    if (character === ' ') {
        return 'At least 5 letters required to write space';
    }
    if (allOwnedCharacters.includes(character.toLowerCase())) {
        return 'At least 10 letters required to write in uppercase';
    }
    if ('.,?!-'.includes(character)) {
        return 'At least 15 letters required to write ' + character;
    }
    if ('1234567890'.includes(character)) {
        return 'At least 20 letters required to write numbers';
    }
    const itemType = itemTypeToEmoji.getByCharacter(character.toLowerCase());
    if (itemType) {
        return 'You don\'t own ' + itemTypeToEmoji[itemType].translation;
    }
    if (allAscii.includes(character)) {
        return 'You must own all letters to write ' + character;
    }
    return 'No one can write ' + character;
};

function isSingleTwoCharEmoji(str) {
    if (str.length !== 2) return false;
    const firstCode = str.charCodeAt(0);
    const secondCode = str.charCodeAt(1);

    // Check if the codes fall in the surrogate pair range for emojis
    return firstCode >= 0xD800 && firstCode <= 0xDBFF && secondCode >= 0xDC00 && secondCode <= 0xDFFF;
}

export default getUnownedMessage;
export {isOnlyAscii, allAscii};